import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["$formControlUse"];
import { INPUT_FONT_SIZE } from 'HubStyleTokens/sizes';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
// Can remove this manually prop-omitting nonsense when styled-components transient props are supported
// https://styled-components.com/docs/api#transient-props
// https://git.hubteam.com/HubSpot/Frontend/issues/1770
export const HiddenMaskedDisplay = styled(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_ref => {
  let props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, props));
}).withConfig({
  displayName: "HiddenMaskedDisplay",
  componentId: "omxnej-0"
})(["visibility:hidden;", ""], ({
  $formControlUse
}) =>
// table cells use the default font size
$formControlUse !== 'table-cell' ? `font-size: ${INPUT_FONT_SIZE};` : '');